import { useFetcher } from "@remix-run/react";
import { ShirtspaceResponseMessage } from "@services/shirtspace.types";
import get from "lodash/get";
import { useEffect, useState } from "react";

const useCreateAccountWizard = <T>(onSuccess: () => void) => {
  const [errors, setErrors] = useState<
    Record<string, ShirtspaceResponseMessage>
  >({});

  const fetcher = useFetcher<T>();

  useEffect(() => {
    if (get(fetcher, "data.ok") === true) {
      setErrors({});
      onSuccess();
    } else {
      const messages = get(fetcher, "data.messages", []);

      const errorsHash = messages.reduce(
        (
          hash: Record<string, ShirtspaceResponseMessage>,
          message: ShirtspaceResponseMessage,
        ) => {
          hash[message.attribute ?? "form"] = message;
          return hash;
        },
        {},
      );

      setErrors(errorsHash);
    }
  }, [fetcher.data]);

  return {
    errors,
    fetcher,
  };
};

export default useCreateAccountWizard;
